import { buildPrompt } from '@/ai/utils/promptBuilder'
import { examples } from '@/ai/prompts/common/examples'
import { transformWorkflow } from '@/ai/utils/transformWorkflow'
import { systemMessages } from '@/ai/prompts/common/systemMessages'
import { getJsonArrayOutputFormatting } from '@/ai/prompts/common/formatting'
import { createSystemMessage, createUserMessage } from '@/ai/utils/promptUtils'

export const buildWorkflowDiagramPrompt = ({ workflow }) => {
  const messages = []

  const systemContent = buildPrompt([systemMessages.EVENT_MODELING_DDD_EXPERT])
  messages.push(createSystemMessage(systemContent))

  const promptSections = []

  promptSections.push({
    title: 'Request',
    content: [
      `This step represents the starting point of both Event Modeling and Event Storming: brainstorming
      domain events and arranging them on a timeline. Your task is to identify and list all state-changing
      Domain Events in chronological order, based on the provided Workflow Description (a business process
      or project scope). A state-changing Domain Event is the result of an actor (human role or Automation)
      invoking a state-changing command (create, update, or delete) on an aggregate. For each event,
      include the following:`,
      '- **Role:** The actor invoking the command.',
      '  - If it’s a person: use a short role name (e.g. SalesRep, Customer, Courier).',
      '  - If it’s automated: always use exactly the word Automation.',
      '  - Maximum length: 18 characters.',
      '- **Domain Event Description:** State-changing event written as AggregateName + PastTenseVerb. Use spaces between words.',
      '  - The aggregate is the entity being created, updated, or deleted (business entity whose lifecycle state is being changed).',
      '  - Examples: Order Placed, Customer Registered, Payment Cancelled.',
      '  - Maximum length: 40 characters.'
    ]
  })

  promptSections.push({
    title: 'Workflow Description',
    content: `\`${workflow.aiDescription}\`` || 'N/A'
  })

  const { events, entities } = transformWorkflow(workflow)

  promptSections.push({
    title: 'Current Workflow (Optional)',
    contentType: 'codeblock',
    language: 'json',
    content: JSON.stringify({ domainEvents: events })
  })

  promptSections.push({
    title: 'Existing Entities (Optional): Use this information if applicable.',
    contentType: 'codeblock',
    language: 'json',
    content: JSON.stringify({ entities })
  })

  promptSections.push({
    title: 'Formatting',
    flattenLines: false,
    content: getJsonArrayOutputFormatting(JSON.stringify(examples.workflowDiagram))
  })

  const userContent = buildPrompt(promptSections)
  messages.push(createUserMessage(userContent))

  return messages
}
